import {
  Notice
} from 'view-design';

export default {
  TranslationJson: ['getEstimated'],
  getErrorCodeText (key) {
    const codeItems = {
      1: '成功',
      2: '目前无数据',
      3: '参数有误',
      4: '類型錯誤',
      5: '权限不足',
      6: 'Token无效',
      8: '修改失败',
      9: '无修改',
      10: '伺服器忙碌中…请稍后再试',
      11: '请求过于频繁',
      12: '该请求已处理过',
      13: '验证码过期，请重新验证',
      14: '验证失败',
      15: '会员模式不支援',
      20: '帐密不得為空',
      21: '查无此帐户',
      22: '帐户重复',
      23: '帐号或密码不正确',
      24: '该使用者已被锁定',
      25: '该使用者已被停用',
      26: '该使用者已被停押',
      27: '该操作员群组已关闭登录功能',
      28: '旧密码输入错误',
      29: '新密码不得与旧密码相同',
      30: '已设定过第二组密码',
      31: '此会员尚未设定提款密码',
      32: '提款密码错误',
      33: '余额不足',
      34: '超出上层可分配最大信用额度',
      35: '给予下层占成额低于下层已使用的占成',
      36: '上层余额不足，无法进行充值',
      37: '余额不足，无法进行提领',
      39: '卡号重复',
      40: '查无卡号',
      41: '查无此邀请码',
      42: '请输入提款密码',
      43: '提款失败',
      47: '登入异常',
      48: '重复登录',
      49: '逾时登出',
      50: '该角色禁止下注',
      51: '赔率超出',
      52: '游戏数与接收游戏数不同',
      53: '余额不足',
      54: '超出额度限制',
      55: '非下注时间',
      56: '下注资料格式错误(非该api可接受游戏)',
      57: '注单重复',
      60: '赔率已变动',
      61: '超出最大赔率，设為最大赔率',
      62: '超出赔率差限制，已设為最大赔率差',
      63: '赔率差大于0,不可超出上层赔率,已将赔率差调整為0',
      65: '未开放补货权限',
      66: '超出目前占成，不得超额补货',
      67: '该玩法关闭连动',
      68: '玩法已停押',
      69: '未开放补货',
      70: '该日期已新增过期数量',
      71: '期数尚未备份,请等待期数备份完毕',
      72: '目前為关盘状态，若要修正状态请连动修正关盘时间',
      73: '目前期数状态不得使用该动作',
      74: '无号码被设置',
      75: '结算中',
      76: '重复结算，因此取消动作',
      77: '尚未设定号码，因此取消动作',
      78: '已结算，无法变动注单',
      79: '不得修改历史注单',
      80: '通道重复',
      81: '已结算',
      82: '未结算',
      83: '期数已过期',
      84: '期数重复',
      90: 'CQ9连线失败，请重新尝试',
      91: '此帐户尚未开放CQ9',
      92: '查无CQ9帐户或尚未连线过CQ9游戏',
      93: '查询无该订单号',
      94: '查询管道异常,请联络客服',
      98: '该站尚未开通',
      99: '连接站点错误',
      100: '外接部份，提供msg直接显示'
    }
    let result = codeItems[key]
    return result
  },
  Notice (res) {
    if (!res.code) return
    const message = this.getErrorCodeText(res.code)
    const duration = 5

    if (res.code == 1) {
      Notice.success({ duration, title: message })
    } else if (res.code == 9) {
      Notice.warning({ duration, title: message })
    } else if (res.code == 100) {
      Notice.error({ duration, title: '提示', desc: res.msg })
    } else {
      Notice.error({ duration, title: '提示', desc: message })
    }
  },
  checkState (value) {
    const CheckNotJson = value.config.url.split('/').some(it => this.TranslationJson.indexOf(it) !== -1) // 判斷該格式不是Json且需要轉譯
    const res = !CheckNotJson
      ? value.data
      : JSON.parse(value.data)
    if ('status' in res === false && 'code' in res === false) return
    this.Notice(res)
    if (res.code == 3) throw new Error(value.config.url)
    return true
  }
}